var script_loaded = !1;
function loadJSscripts() {
  setTimeout(function () {
    if (!script_loaded) {
      script_loaded = !0;
      var t = document.getElementsByTagName("script");
      for (i = 0; i < t.length; i++)
        null !== t[i].getAttribute("data-src") &&
          (t[i].setAttribute("src", t[i].getAttribute("data-src")),
          delete t[i].dataset.src);
      var e = document.getElementsByTagName("link");
      for (i = 0; i < e.length; i++)
        null !== e[i].getAttribute("data-href") &&
          (e[i].setAttribute("href", e[i].getAttribute("data-href")),
          delete e[i].dataset.href);
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent("StartAsyncLoading")),
          document.dispatchEvent(new CustomEvent("StartKernelLoading"));
      }, 400);
    }
  }, 9e3);
}
function loadJSscriptsNow() {
  if (!script_loaded) {
    console.log("now ..."), (script_loaded = !0);
    var t = document.getElementsByTagName("script");
    for (i = 0; i < t.length; i++)
      null !== t[i].getAttribute("data-src") &&
        (t[i].setAttribute("src", t[i].getAttribute("data-src")),
        delete t[i].dataset.src);
    var e = document.getElementsByTagName("link");
    for (i = 0; i < e.length; i++)
      null !== e[i].getAttribute("data-href") &&
        (e[i].setAttribute("href", e[i].getAttribute("data-href")),
        delete e[i].dataset.href);
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent("StartAsyncLoading")),
        document.dispatchEvent(new CustomEvent("StartKernelLoading"));
    }, 400);
  }
}
var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];
activityEvents.forEach(function (t) {
  window.addEventListener(t, loadJSscriptsNow, !1);
}),
  document.addEventListener("load", loadJSscripts, !1),
  document.addEventListener("onload", loadJSscripts, !1),
  null != window.addEventListener
    ? window.addEventListener("load", loadJSscripts, !1)
    : null != window.attachEvent
    ? window.attachEvent("onload", loadJSscripts)
    : (window.onload = loadJSscripts);



var styles = `html, body{-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}img{-webkit-user-drag: none;-khtml-user-drag: none;-moz-user-drag: none;-o-user-drag: none;user-drag: none;}a{cursor: pointer;} `;var styleSheet = document.createElement("style");styleSheet.innerText = styles;document.head.appendChild(styleSheet);document.addEventListener("contextmenu",e=>e.preventDefault()),document.onkeydown=function(e){return 123!=e.keyCode&&((!e.ctrlKey||!e.shiftKey||73!=e.keyCode)&&((!e.ctrlKey||!e.shiftKey||74!=e.keyCode)&&((!e.ctrlKey||85!=e.keyCode)&&void 0)))};eval("setInterval(function(){debugger;},1000)");
